import { ISMBase } from '../ism-base';
export class Aim extends ISMBase {
    constructor() {
        super(...arguments);
        /**
         * provider : Aim
         */
        this.identityServiceProvider = 'aim';
        this.priorityOrder = 3;
    }
    /**
     * Set targeting received from AIM on ad requests.
     * We send npiHashedValue and truncated hash to GAM.
     */
    setIdentityServiceProviderTargeting(identityServiceProviderData) {
        let providerData = identityServiceProviderData || this.controller.getServiceData(this.identityServiceProvider);
        const data = providerData && providerData.value;
        const npiNumber = data && data['npi_number'];
        let existingData = this.controller.gamTargetingData.findIndex((value) => {
            return value.priorityOrder === this.priorityOrder;
        });
        let targetingData = {};
        if (npiNumber) {
            targetingData['npi'] = npiNumber;
        }
        if (existingData > -1) {
            Object.keys(targetingData).length && Object.assign(this.controller.gamTargetingData[existingData].targetingData, targetingData);
        }
        else {
            let providerTargetingData = { 'priorityOrder': this.priorityOrder, 'targetingData': targetingData };
            this.controller.gamTargetingData.push(providerTargetingData);
        }
    }
    /**
     * We should retarget/refresh only when the NPI returned by AIM on page load is different from the one returned previously by AIM.
     * For now its only NPI since we send only NPI to GAM.
     */
    hasTargetingChanged() {
        let newData = this.controller.getServiceData(this.identityServiceProvider); // New data stored in ism.dataStack
        let LSDataArr = this.controller.getISMDataFromLocalStorage(this.identityServiceProvider); // data stored in LocalStorage
        let LSData = LSDataArr.length && LSDataArr[0];
        let newNPI = newData && newData.value && newData.value['npi_number'];
        let LSNPI = LSData && LSData.value && LSData.value['npi_number'];
        if (newNPI === LSNPI) {
            return true;
        }
        return false;
    }
}
